import React, { ReactNode } from "react";
import Loader from "./Loader";

// @ts-ignore
interface Props extends React.ComponentProps<"button"> {
  children: ReactNode;
  style?: React.CSSProperties | undefined;
  className?: string;
  childClassname?: string;
  type:
    | "primary"
    | "primary-white"
    | "secondary"
    | "tertiary"
    | "golden"
    | "positive"
    | "negative"
    | "primary-dark";
  iconName?: string;
  iconColor?: string;
  disabled?: boolean;
  loading?: boolean;
}

function Button({
  style,
  children,
  className,
  childClassname,
  type,
  iconName,
  iconColor,
  disabled = false,
  loading = false,
  ...props
}: Props) {
  const isPrimaryWhite = type === "primary-white";
  const isSecondary = type === "secondary";
  const isTertiary = type === "tertiary";

  const getBgColorClass = () => {
    if (disabled) {
      return type === "primary-dark"
        ? "bg-grey-light opacity-30"
        : "bg-grey-light-border";
    }
    if (loading) {
      return type === "primary-dark" ? "bg-grey-dark" : "bg-purple-light";
    }
    switch (type) {
      case "secondary":
        return "bg-transparent  hover:bg-gradient-background-medium";
      case "primary-dark":
        return "bg-purple-500 hover:opacity-80";
      case "tertiary":
        return "bg-transparent  hover:bg-[#E9E2F4]";
      case "primary-white":
        return "bg-gradient-background-medium";
      case "golden":
        return "bg-golden-btn";
      case "positive":
        return "bg-status-positive";
      case "negative":
        return "bg-status-negative";
      default:
        return "bg-gradient-brand-dark hover:opacity-90";
    }
  };
  const getTextClass = () => {
    if (disabled) {
      return type === "primary-dark" ? "text-grey-darker" : "text-grey-light";
    }
    switch (type) {
      case "secondary":
      case "tertiary":
        return "bg-text-grad-brand-dark";
      case "primary-dark":
        return "text-grey-dark";
      case "primary-white":
        return "bg-gradient-brand-dark bg-clip-text text-transparent";
      case "golden":
        return "text-[#fff]";
      default:
        return "text-white";
    }
  };
  const getBorderClass = () => {
    if (isSecondary) {
      return `border  ${
        disabled ? "border-grey-light" : "border-grad-brand-dark-border"
      }`;
    }
    if (isTertiary) {
      return ``;
    }
  };
  return (
    <button
      disabled={disabled || loading}
      style={style}
      className={`py-3 px-4 text-sm font-semibold rounded-[6px] ${getBgColorClass()} ${getBorderClass()} ${
        loading ? "opacity-100" : ""
      }  ${className}`}
      {...props}
    >
      <div className="flex gap-2 items-center justify-center">
        {loading ? (
          <Loader />
        ) : (
          <p className={`${getTextClass()} ${childClassname}`}>{children}</p>
        )}
      </div>
    </button>
  );
}

Button.defaultProps = {
  type: "primary",
};

export default Button;
